<template>
  <div class="modal_wrapper">
    <div class="container">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="caution" height="25px" />
          {{ confirm }}
        </div>
        <div class="modal_body">
          <div class="body">
            <div>{{ question }}</div>
            <div style="margin-top: 10px;">宛先: {{ userName }}さん</div>
            <div class="message_area">{{ message }}</div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
            <input
              type="button"
              :value="okButton"
              class="finish_button"
              @click="$emit('ok')"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['userName', 'message'],
  data() {
    return {
      caution: require('../../img/caution.png'),
      question: '以下の内容で送信してよろしいですか？',
      confirm: '確認',
      cancelButton: 'キャンセル',
      okButton: '送信'
    }
  }
}
</script>
<style scoped>
.modal_container {
  height: 350px;
}
.modal_wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.body {
  width: 100%;
  height: 117px;
  padding-top: 40px;
}
.message_area {
  white-space: pre-wrap;
  max-height: 110px;
  overflow-y: auto;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/sendMessageConfirmModalWindow.vue